/** @module Camunda/PriorityRenderer */
define([
	"dojo/_base/declare",
	"csi",
	"csi/locale",
	"csi/widget/CustomIconWithLabel",
	"csi/xml",
	"./PriorityIconRenderer",
	"./TaskDueDateOrPriorityAction"
], function(declare,csi,locale,CustomIconWithLabel,xml,PriorityIconRenderer,TaskDueDateOrPriorityAction) {

	return declare(PriorityIconRenderer, {
		/**
		 * @override
		 * Use a special action to disable editing if not Assignee
		 */
		_getAction: function() {
			return new TaskDueDateOrPriorityAction();
		},

		/**
		 * @override
		 * Use icons
		 */
		isIcon: function(enumId) {
			return true;
		},

		/**
		 * @override
		 * Render Icon + Label for drop down
		 */
		_getIconLabel: function(h, item, store) {
			const value = item[store.idProperty];
			const priorityText = xml.enumGetText(value);

			if (priorityText) {
				return CustomIconWithLabel.getIconHtml({
					icon: this.getPriorityIcon(priorityText),
					label: locale.resource(value)
				});
			}

			return csi.EMPTY_CHAR;
		},

		/**
		 * @override
		 * Draw material icon and localized label
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const value = this._getValue(ctx, h);
			const priorityText = xml.enumGetText(value);

			if (priorityText) {
				new CustomIconWithLabel({
					icon: this.getPriorityIcon(priorityText),
					label: locale.resource(value)
				}).placeAt(refNode);
				
				return true;
			}
			
			return false;
		}
	});
});
